<mat-select [formControl]="site" [multiple]="multiple" class="form-control">

    <mat-select-trigger>{{ getSelectLabel() }}</mat-select-trigger>

    <input [formControl]="siteFilter" placeholder="{{ 'common.filter' | translate }}..." autocomplete="off" class="w-full dt-filter-input" style="border: none;outline: none;">

    <mat-option *ngIf="!multiple" [value]="null">( Empty )</mat-option>

    <ng-container *ngFor="let site of sites$ | async">
        <mat-option [ngStyle]="{'display': site.visiable ? '' : 'none'}" [value]="site">
            {{ labels.get(site.site) }} <span class="mat-hint">({{ site.name }})</span>
        </mat-option>
    </ng-container>

</mat-select>
